export default __webpack_public_path__ + "a4b6378.png";